import * as React from "react"

function SvgArrowUp(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 18 18" fill="none" {...props}>
      <path
        d="M0 9l1.586 1.586L7.875 4.31V18h2.25V4.309l6.289 6.277L18 9 9 0 0 9z"
        fill="#2AA12A"
      />
    </svg>
  )
}

export default SvgArrowUp

